<template>
  <VCard
    v-show="!isLoading"
    class="trip-card mb-6"
    :data-test="`trip-${trip.bookingId}`"
    :class="{ 'trip-card--collapsed': hiddenAfterCancellation }"
  >
    <Header
      :trip="trip"
      @open-cancellation-dialog="isShowCancellationDialog = true"
      @start-edit-comment="isEditingComment = true"
    />
    <hr />
    <VRow class="mt-4">
      <VCol cols="12" lg="12" md="12" sm="12" xs="12" class="py-0 mb-4">
        <TripStops
          :stops="trip.stops"
          :bookingStatus="trip.bookingStatus"
          :estimatedPickUpTime="trip.estimatedPickUpTime"
          :estimatedDropOffTime="trip.estimatedDropOffTime"
          :timeZone="trip.timeZone"
          :privateShuttle="trip.privateShuttle"
          :departureDateTime="trip.departureDateTime"
        />
      </VCol>
    </VRow>
    <hr />
    <VRow class="mt-4">
      <VCol cols="12" lg="12" md="12" sm="12" xs="12" class="py-0 mb-4">
        <Price :trip="trip" :appConfig="appConfig" />
      </VCol>
    </VRow>
    <hr v-if="trip.anotherPersonIsRiding" />
    <PassengerInfo
      v-if="trip.anotherPersonIsRiding"
      :passengerInfo="trip.passengerDetails[0]"
    />
    <hr v-if="isShowDriverInfo" />
    <VehicleDriverInfo
      :trip="trip"
      @showDriverInfo="(val) => (isShowDriverInfo = val)"
    />
    <hr v-if="trip.comment" />
    <Comment
      :trip="trip"
      :is-editing-comment="isEditingComment"
      @end-edit-comment="endEditComment"
    />
    <Footer :trip="trip" />
    <CancellationDialog
      :visible="isShowCancellationDialog"
      :bookingId="trip.bookingId"
      :bookingPrice="trip.bookingPrice"
      @close="isShowCancellationDialog = false"
      @onCancelled="onCancelled"
    />
  </VCard>
</template>

<script lang="ts">
export default {
  name: 'TripCard',
};
</script>

<script setup lang="ts">
import { ref } from 'vue';
import CancellationDialog from '@slg/web-customer-shared/src/components/trips/CancellationDialog.vue';
import TripStops from './components/TripStops.vue';
import Header from './components/Header.vue';
import Price from './components/Price.vue';
import PassengerInfo from './components/PassengerInfo.vue';
import VehicleDriverInfo from './components/VehicleDriverInfo.vue';
import Comment from './components/Comment.vue';
import Footer from './components/Footer.vue';

const props = defineProps({
  trip: {
    type: Object,
    required: true,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  appConfig: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['onCancelled']);

const hiddenAfterCancellation = ref(false);
const isShowCancellationDialog = ref(false);
const isEditingComment = ref(false);
const isShowDriverInfo = ref(false);

function onCancelled() {
  emit('onCancelled', props.trip);
  hiddenAfterCancellation.value = true;
}

function endEditComment(comment: string) {
  props.trip.comment = comment;
  isEditingComment.value = false;
}
</script>

<style lang="scss" scoped>
.trip-card {
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  transition: max-height 0.3s ease-in;
  max-height: 100vh;

  &--collapsed {
    margin-bottom: 10px !important;
    max-height: 0;
    transition: max-height 0.3s ease-out;
    overflow: hidden;
  }

  .row {
    padding: 0px 16px;
  }
}
</style>
